import { NgModule } from 'ng-metadata/core';
import { EmptyStateComponent } from './empty-state.component';

/**
 * @ngdoc module
 * @name mw.components.emptyState
 * @description
 *
 * Empty state when there is no information to be shown
 */
@NgModule({
  declarations: [ EmptyStateComponent ]
})
export class EmptyStateModule {}




// WEBPACK FOOTER //
// ./src/lib/components/empty-state/empty-state.module.ts